import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../../components/Button/Button';
import Link from '../../../../components/Link';

export type customOnSaveModal = React.PropsWithoutRef<{
  handleBackToResults: any;
}>;

const OnSaveContent = ({
  handleBackToResults,
  ...props
}: customOnSaveModal) => {
  return (
    <Container className="p-0 p-lg-11 mt-10 mb-12 bg-backgroud-gray rounded-1">
      <Row className="m-0 text-center">
        <h5 className="m-0">Save Estimate</h5>
      </Row>
      <Row className="m-0 mt-7">
        <Col className={'col-12 text-center'}>
          <img
            src={`${process.env.PUBLIC_URL}/${'save-estimate.png'}`}
            alt={`save-estimate`}
          />
        </Col>

        <Col className={'col-12 p-0 mt-7 fw-light lh-xs text-center'}>
          <span>
            Your estimate has been saved successfully. All of your saved
            estimates can be accessed in the{' '}
            <span className="d-inline-block me-1">
              <Link
                isBlue
                className={'py-0 d-flex justify-content-space-between'}
              >
                Saved Estimates
              </Link>
            </span>
            section.
          </span>
        </Col>
      </Row>
      <Col className="p-0 text-center">
        <Button
          variant="primary-outline"
          className="order-1 order-lg-2 mt-10"
          onClick={handleBackToResults}
        >
          Back to Results
        </Button>
        <Button variant="primary" className="order-1 order-lg-2 mt-10 ms-4">
          Go to Saved Estimates
        </Button>
      </Col>
    </Container>
  );
};

export default OnSaveContent;
